
	import {
		Component,
		Vue
	} from "vue-property-decorator";
	import PageFooter from '@/components/page-footer.vue';
	import PickerDate from '@/components/picker-date.vue';
	import checkDetailDialog from './components/check-detail-dialog.vue';
	import RadioButton from '@/components/radio-button.vue';
	
	import {
		checkStatisByMemberList,
		orderpayStatisByMemberList
	} from '@/api/order'
	import{
		getSearchDate,
		nextDay
	}from "@/utils/index"

	@Component({
		name: 'agency-check-record',
		components: {
			PageFooter,
			PickerDate,
			checkDetailDialog,
			RadioButton
		}
	})
	export default class AgencyCheckRecord extends Vue {
		private defaultAvatar = 'https://cdn2024.routuan.com/routuan/image/20230110-0f54988a-9589-45bc-ad27-844c60e80f36.png'
		private id: number = +this.$route.query.id;
		private radioType = 1;
		private radioList: any = [{
				label: '已支付',
				value: 1
			}, {
				label: '已审核',
				value: 2
			}, 
		];
		
		private showDetail = false;
		private memberId = 0;
		
		private list: any = [];
		private pageNo = 1;
		private pageSize = 10;
		private total = 0;
		private keywords = '';
		private filterTime: any = getSearchDate(2).join('/')
		private filterCheckTime: any = ''
		private selectTime = 0
		private selectTimes = [{
			label: '下单时间',
			value: 0
		}]
		private checkTime = 0
		private checkTimes = [{
			label: '审核时间',
			value: 0
		}]


		private keywords2 = ''
		private iscompany = null
		private iscompanylist=[
			{value:null,label:'全部'},
			{value:true,label:'是'},
			{value:false,label:'否'},
		]
		private sequencephone = ''
		private filterTime2: any = getSearchDate(1).join('/')
		private filterCheckTime2: any = ''
		private tableloading = false
		private paylist:any = []
		
		private mounted() {
			// this.getList();
			this.getpaylist()
			// setTimeout(()=>{
			// 	this.showDetail = true;
			// }, 2000)
		}

		private handleChange(e){
			this.radioType = e
			this.pageNo = 1
			if(e==1){
				this.getpaylist()
			}else{
				this.getList()
			}
		}


		private lookpaydetail(row){
			this.$router.push({
				path:'paydetail',
				query:{
					Id:row.CustomerId,
					Name:encodeURIComponent(row.Name),
					filterTime:this.filterTime2,
					filterCheckTime:this.filterCheckTime2
				}
			})
		}
		private async getpaylist(){
			try{
				this.tableloading = true
				let data:any = {
					Keywords:this.keywords2,
					SuperIsCompany:this.iscompany,
					Skip:(this.pageNo-1)*this.pageSize,
					Take:this.pageSize,
				}
				if (this.filterTime2){
					let times = this.filterTime2.split('/');
					data.AddStartTime = times[0]
					data.AddEndTime = nextDay(times[1],1)
				}
				if (this.filterCheckTime2){
					let times = this.filterCheckTime2.split('/');
					data.PayStartTime = times[0]
					data.PayEndTime = nextDay(times[1],1)
				}
				let res = await orderpayStatisByMemberList(data)
				if(res.IsSuccess){
					this.paylist = res.Result.Results 
					// this.paylist = [{
					// 	MemberId:5,
					// 	Name:'李四'
					// }]
					this.total = res.Result.Total
				}
			}finally{
				this.tableloading = false
			}
		}

		
		private exportlist(){
			let url = location.origin + '/pc/order/checkStatisByMemberExport' + 
								'?Keywords=' + (this.keywords?this.keywords:'')

								if (this.filterTime){
									let times = this.filterTime.split('/');
									url += '&AddStartTime=' + (times[0]?times[0]:'')
									url += '&AddEndTime=' + (times[1]?nextDay(times[1],1):'')
								}
								if (this.filterCheckTime){
									let checkTimes = this.filterCheckTime.split('/');
									url += '&CheckStartTime=' + (checkTimes[0]?checkTimes[0]:'')
									url += '&CheckEndTime=' + (checkTimes[1]?nextDay(checkTimes[1],1):'')
								}

			window.open(url)

		}

		private changePage(num: number) {
			this.pageNo = num;
			if(this.radioType==1){
				this.getpaylist()
			}else{
				this.getList()
			}
		}
		
		private doSearch() {
			this.pageNo = 1;
			if(this.radioType==1){
				this.getpaylist()
			}else{
				this.getList()
			}
		}
		
		private clearSearch() {
			this.pageNo = 1;
			if(this.radioType==1){
				this.keywords2 = ''
				this.iscompany = null
				this.sequencephone = ''
				this.filterTime2 = getSearchDate(1).join('/')
				this.filterCheckTime2 = '';
				this.getpaylist()
			}else{
				this.keywords = ''
				this.filterTime = getSearchDate(2).join('/')
				this.filterCheckTime = '';
				this.getList()
			}
		}

		private async getList() {
			try {
				this.tableloading = true
				let times: any = '';
				if (this.filterTime){
					times = this.filterTime.split('/');
				}
				
				let checkTimes: any = '';
				if (this.filterCheckTime){
					checkTimes = this.filterCheckTime.split('/');
				}
				
				const res: any = await checkStatisByMemberList({
					Skip: (this.pageNo-1)*this.pageSize,
					Take: this.pageSize,
					AddStartTime: times ? times[0]:'',
					AddEndTime: times ? nextDay(times[1],1):'',
					CheckStartTime: checkTimes ? checkTimes[0]:'',
					CheckEndTime: checkTimes ? nextDay(checkTimes[1],1):'',
					Keywords: this.keywords
				})
				this.list = res.Result.Results;
				this.total = res.Result.Total;
			} catch (e) {
				console.log(e)
			}finally{
				this.tableloading = false
			}
		}

		private async toDetail(id: number) {
			// this.$router.push({
			// 	name: 'Agency_Check_Record_Detail',
			// 	query: {
			// 		id: id + '',
			// 		userId: this.id + ''
			// 	}
			// })
			this.memberId = id;
			this.showDetail = true;
		}
	}
